import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WhyChooseUsTable from "../../components/why-choose-us/WhyChooseUsTable";

const WhyChooseUsListPage = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <WhyChooseUsTable />
        </WrapperSection>
    );
};

export default WhyChooseUsListPage;
